import React from 'react';
import { FooterContainer, FooterLink, FooterText } from './Footer.styled';

const Footer = () => {
  return (
    <FooterContainer>
      <FooterText>Application Developed by</FooterText>{' '}
      <FooterLink onClick={() => window.open('https://urbancompasssoftware.com/', '_blank')}>
        Urban Compass
      </FooterLink>
    </FooterContainer>
  );
};

export default Footer;
